import { handleActions } from 'redux-actions';
import { hash, Map as ImmutableMap } from 'immutable';

import { coreActions } from 'companion-app-components/flux/core-actions';

import * as actions from './actions';
import { mkPayeeListStore, type PayeeList, type Payee } from './types';

export function upsertResources(state: PayeeList, payeesByAccountId: ImmutableMap<string, ImmutableMap<string, Payee>>) {

  let resources = state.payeesByAccountId;

  payeesByAccountId.forEach((res, key) => {
    resources = resources.set(key, res);
  });

  return state.set('payeesByAccountId', resources).set('loadPending', false);
}

const reducer = handleActions<
PayeeList,
| ReturnType<typeof coreActions.sanitize>
| ReturnType<typeof actions.updatePayeeListAsync>
| ReturnType<typeof actions.updatePayeeList>
| ReturnType<typeof actions.createPayeeList>
| ReturnType<typeof actions.updatePayeeListSuccess>
| ReturnType<typeof actions.createPayeeListSuccess>
| ReturnType<typeof actions.updatePayeeListFailure>
| ReturnType<typeof actions.createPayeeListFailure>
>({

  [coreActions.sanitize.toString()]: (state) =>
    state.set('payeesByAccountId', state.payeesByAccountId.map((resources) => resources.mapEntries(([id, resource]) => {
      const hashedTxn = resource.txn
        ? resource.txn.merge({
          payee: hash(resource.txn.payee).toString(),
          memo: hash(resource.txn.memo).toString(),
          ...(resource.txn.check && {
            check: { memo: hash(resource.txn.check.memo).toString() },
          }),
          ...(resource.txn.cpData && {
            cpData: {
              payee: hash(resource.txn.cpData.payee).toString(),
              inferredPayee: hash(resource.txn.cpData.inferredPayee).toString(),
              memo: hash(resource.txn.cpData.memo).toString(),
            },
          }),
        })
        : undefined;

      const sanitizedResource = resource.merge({
        name: hash(resource.name).toString(),
        catString: hash(resource.catString).toString(),
        tagString: hash(resource.tagString).toString(),
        ...(hashedTxn ? { txn: hashedTxn } : {}),
      });

      return [hash(id).toString(), sanitizedResource];
    }))),

  [actions.updatePayeeListAsync.toString()]: (state: PayeeList, data: Record<string, any>) => {
    setTimeout(() => {
      data.asyncDispatch(actions.updatePayeeList(data.payload));
    }, 3000);
    return state;
  },

  [actions.updatePayeeList.toString()]: (state) => state,
  [actions.createPayeeList.toString()]: (state) => state,

  [actions.updatePayeeListSuccess.toString()]: (state, { payload: data }) => upsertResources(state, data),
  [actions.createPayeeListSuccess.toString()]: (state, { payload: data }) => upsertResources(state, data),

  [actions.updatePayeeListFailure.toString()]:
    (state, { payload: _error }) => state,
  [actions.createPayeeListFailure.toString()]:
    (state, { payload: _error }) => state,

}, mkPayeeListStore());

export const REDUCER_KEY = 'payeeListStore';
export default reducer;
